import {
  ResponseEnum,
  type ShopOptionRequest,
  type ShopOptionResults,
} from "@b2bportal/rbc-activities-api";
import { activitiesApi } from "@overrides/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ActivitiesState } from "../../../../store";

export type FetchShopOptionFulfillResponse = {
  shopOption: ShopOptionResults;
};

export type FetchShopOptionParams = {
  request: ShopOptionRequest;
  resetShopOptions?: boolean;
};

export const fetchActivitiesShopOption = createAsyncThunk<
  FetchShopOptionFulfillResponse,
  FetchShopOptionParams,
  { state: ActivitiesState; rejectValue: { error: string } }
>("activitiesShop/fetchActivitiesShopOption", async ({ request }, thunkAPI) => {
  try {
    const shopOptionRes =
      await activitiesApi.apiV0ActivitiesShopOptionPost(request);
    if (shopOptionRes.data.Response === ResponseEnum.Success) {
      return {
        shopOption: shopOptionRes.data.value,
      };
    } else {
      return thunkAPI.rejectWithValue({
        error: shopOptionRes.data.errors[0].details ?? "Unknown error",
      });
    }
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: String(error) });
  }
});
